/**
 * @file paddle Live
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import useLiveHooks from './LiveHooks';
import LiveCardGroup from './components/live-card/LiveCardGroup';
import LiveCalendar from './components/live-calendar/LiveCalendar';


const Live: React.FC = () => {

    const {
        banner,
        liveCard,
        liveCalendar
    } = useLiveHooks();

    return (
        <div className="page paddle-live-page">
            <Header />
            <div className="paddle-live-banner">{banner?.title}</div>
            <div className="paddle-live-page-content">
                {!!liveCard
                && (
                    <div className="paddle-live-content">
                        <LiveCardGroup
                            {...liveCard}
                        />
                    </div>
                )}

                {!!liveCalendar
                && (
                    <div className="paddle-live-content">
                        <LiveCalendar
                            {...liveCalendar}
                        />
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default React.memo(Live);
